/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelReviewItem } from './HotelReviewItem';
import {
    HotelReviewItemFromJSON,
    HotelReviewItemFromJSONTyped,
    HotelReviewItemToJSON,
    HotelReviewItemToJSONTyped,
} from './HotelReviewItem';

/**
 * A hotel review
 * @export
 * @interface HotelReviewV2
 */
export interface HotelReviewV2 {
    /**
     * 
     * @type {string}
     * @memberof HotelReviewV2
     */
    vervotechPropertyId?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelReviewV2
     */
    placeId?: string;
    /**
     * 
     * @type {Array<HotelReviewItem>}
     * @memberof HotelReviewV2
     */
    reviews?: Array<HotelReviewItem>;
    /**
     * 
     * @type {Error}
     * @memberof HotelReviewV2
     */
    error?: Error;
}

/**
 * Check if a given object implements the HotelReviewV2 interface.
 */
export function instanceOfHotelReviewV2(value: object): value is HotelReviewV2 {
    return true;
}

export function HotelReviewV2FromJSON(json: any): HotelReviewV2 {
    return HotelReviewV2FromJSONTyped(json, false);
}

export function HotelReviewV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelReviewV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'vervotechPropertyId': json['vervotech_property_id'] == null ? undefined : json['vervotech_property_id'],
        'placeId': json['place_id'] == null ? undefined : json['place_id'],
        'reviews': json['reviews'] == null ? undefined : ((json['reviews'] as Array<any>).map(HotelReviewItemFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function HotelReviewV2ToJSON(json: any): HotelReviewV2 {
    return HotelReviewV2ToJSONTyped(json, false);
}

export function HotelReviewV2ToJSONTyped(value?: HotelReviewV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vervotech_property_id': value['vervotechPropertyId'],
        'place_id': value['placeId'],
        'reviews': value['reviews'] == null ? undefined : ((value['reviews'] as Array<any>).map(HotelReviewItemToJSON)),
        'error': value['error'],
    };
}

